/** @jsxImportSource @emotion/react */
import { PanelCard } from '../../../design-system/molecules/PanelCard/PanelCard';
import { Badge } from '../../../design-system/atoms/Badge/Badge';
import { Cluster } from '../../../design-system/layout/Cluster';
import type { JobDetailData } from '../../types';
import { jobStatusTone } from '../../types';
import { rowStyle, titleStyle, subStyle } from './JobSummaryCard.styles';

export interface JobSummaryCardProps {
  job: JobDetailData;
}

/** Job 식별 카드. 번호·상태·모듈/트리거/수집기 요약에 활용. 재시도 Job이면 '재시도' 배지 노출. */
export function JobSummaryCard({ job }: JobSummaryCardProps) {
  const isRetry = job.retryOfJobId !== null;
  return (
    <PanelCard>
      <div css={rowStyle}>
        <div>
          <Cluster gap="sm">
            <h2 css={titleStyle}>Job #{job.id}</h2>
            <Badge tone={jobStatusTone(job.status)}>{job.status}</Badge>
            {isRetry && <Badge tone="secondary">재시도</Badge>}
          </Cluster>
          <p css={subStyle}>
            {job.module} · {job.trigger} · {job.collector}
          </p>
        </div>
      </div>
    </PanelCard>
  );
}
